import { motion, useAnimation, useInView } from "framer-motion";
import React, { useState, useRef, useEffect } from "react";
import JumpingLetters from "../JumpingLetters";
import TypingLetters from "../TypingLetters";

const cardVariants = {
    visible: {
        opacity: 1,
        y: 0,
        scale: 1,
        transition: {
            duration: 1,
            type: "spring",
            bounce: "0.6"
            
        }
    },
    hidden: {
        opacity: 0,
        y: -50,
        scale: 0.8
    },


   
}

function ProjectCard( { children } ){
    const controls = useAnimation();
    const ref = useRef(null);
    const inView = useInView(ref);
   

    useEffect(() => {
        if(inView) {
            controls.start("visible");
        }
    }, [controls, inView])


    return(
        <motion.div className="project" 
            ref={ref}
            animate={controls}
            initial="hidden"
            variants={cardVariants}
        >
            {children}
        </motion.div>
    );
}

export default function CodingProjects() {
    const [isHover, setIsHover] = useState(false);
    // const ref = useRef(null);
    // const { scrollYProgress } = useScroll({
    //     target: ref,
    //     offset: ["start start", "end start"],
    // });

    // const backgroundY = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);
    // const textY = useTransform(scrollYProgress, [0, 1], ["0%", "200%"]);

    const controls = useAnimation();
    const ref = useRef(null);
    const inView = useInView(ref);
   

    useEffect(() => {
        if(inView) {
            controls.start("visible");
        }
    }, [controls, inView])
    


    return (
        <motion.div
            initial={{
                opacity: 0,
                x: -50,
                
            }}
            animate={{
                opacity: 1,
                x: 0,
                
            }}
            exit={{
                opacity: 0,
                x: 50
            }}
            transition={{
                duration: 0.5,
                ease: "backInOut"
            }}
    >   
        {/* <h1>CODING PROJECTS</h1> */}
        <span className="page-title-animated"
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            style={{ display: "inline-block", cursor: "pointer" }}
        >
            <JumpingLetters text="Coding" isHover={isHover}/>
        </span>
        
        <div className="page-intro-text">
        <TypingLetters text="Check out my coding projects:"/>
        </div>

        <div className="projects">
            <ProjectCard>
                <div className="project-text">
                    <p className="project-title">Should've Been A Horror Game</p>
                    <p className="project-description">A 3D puzzle adventure game built with Unity</p>
                    <p className="project-description"
                        style={{
                            paddingTop: "5px",
                            paddingLeft: "30px",
                        }}
                    >
                        <li>Designed UI elements and interfaces</li>
                        <li>Implemented player-object interaction system</li>
                    </p>
                    <a href="https://celineh.itch.io/shouldve-been-a-horror-game" className="coding-proj-button" target="_blank" rel="noopener noreferrer">Play Game</a>
                </div>
            </ProjectCard>

            <ProjectCard>
                {/* <div className="placeholder">

                </div> */}
                <div className="project-text">
                    <p className="project-title">Portfolio Website</p>
                    <p className="project-description">Built with React, JavaScript, HTML, and CSS</p>
                    <p className="project-description"
                        style={{
                            paddingTop: "5px",
                            paddingLeft: "30px",
                        }}
                    >
                        <li>Implemented mobile responsive design</li>
                        <li>Animated with Framer Motion</li>
                    </p>
                </div>
            </ProjectCard>

            <ProjectCard>
                <div>
                    <video src={"https://res.cloudinary.com/dmr4kfndo/video/upload/w_600,q_auto,f_auto/minesweeper_p6me45.mp4"} autoPlay muted loop playsInline
                    />
                </div>
                <div className="project-text">
                    <p className="project-title">Minesweeper</p>
                    <p className="project-description">A fully rendered recreation of classic game built with C++ and SFML</p>
                </div>
            </ProjectCard>

            

            

        </div>
    </motion.div>

    );
}